import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
import { types, typesTitles } from "./enums";
/**
 * Payment card class
 */

export class PaymentCard extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getId = () => {
      return this.model.id;
    };

    this.getTitle = () => {
      return this.model.title;
    };

    this.getCardNumber = () => {
      return this.model.card_number;
    };

    this.getType = (asLabel = false) => {
      return asLabel ? PaymentCard.typesTitles[this.model.type || 'unknown'] || PaymentCard.typesTitles['unknown'] : this.model.type;
    };

    this.isPrimary = () => {
      return this.model.main === 1;
    };

    this.getExpired = () => {
      return this.model.expired_at;
    };
  }

  /**
   * Create payment card
   *
   * @param {object} object
   *
   * @return {PaymentCard}
   */
  static create(object) {
    return super.create(object);
  }
  /**
   * Create list payment cards
   *
   * @param {object} objects
   *
   * @return {Array.<PaymentCard>}
   */


  static createList(objects) {
    return super.createList(objects);
  }
  /**
   * Map models
   *
   * @param {Array.<object>} objects
   * @param {function(PaymentCard): undefined} callback
   *
   * @return {Array.<object>}
   */


  static map(objects, callback) {
    return super.map(objects, callback);
  }
  /**
   * Get card id
   *
   * @return {number}
   */


}
PaymentCard.types = types;
PaymentCard.typesTitles = typesTitles;